<template>
	<div>
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<!-- <el-breadcrumb-item>图库</el-breadcrumb-item> -->
					<el-breadcrumb-item>{{codeName.name}}</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_slt">
				<div @click="slt_btn">
					<img src="@/assets/image/icon_tk_slt@2x.png" alt="" class="icon">
					<span>缩略图展示</span>
				</div>
			</div>
			<div class="gall_cont">
				<div class="gall_item" v-for="(items,indexs) in cateData.records" :key="indexs">
					<div class="gall_item_title">
						{{items.name}}
					</div>
					<div class="gall_item_p">
						<router-link class="gall_item_a" v-for="item in items.children" :to="{path: '/galleryDec',query: {id: item.id,mName: items.name,kName: item.name,zName: items.name}}">
							{{item.name}}
						</router-link>
					</div>
				</div>
			</div>
			<div class="gall_fy">
				<div class="block">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="cateData.current"
					 :page-size="cateData.size" layout="prev, pager, next, jumper" :total="cateData.total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				isFlag: true,
				tab_index: 'tk',
				currentPage3: 5,
				cateData: {
					current: 0,
					total: 0,
					size: 0,
				},
				pares: {
					page: 1,
					size: 10,
				}
			}
		},
		computed: {
			codeName() {
				let name = ''
				for (let item of this.fldata) {
					if (item.code == this.gallyIndex) {
						name = item
					}
				}
				return name
			},
			gallyIndex() {
				this.init()
				return this.$store.state.gallyIndex
			},
			fldata() {
				return this.$store.state.fldata
			}
		},
		created() {
		},
		mounted() {
		},
		methods: {
			init(data) {
				setTimeout(() => {
					this.$http.get('/front/gallery/categories', {
						categoryCode: this.codeName.code,
						page: this.pares.page,
						size: this.pares.size,
					}).then(res => {
						let data = res.data
						this.cateData = data
					})
				})
			},
			slt_btn() {
				this.$router.push({
					path: 'gallery_indexTw'
				})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.pares.page = val
				this.init()
			}
		}
	}
</script>

<style lang="less" scoped>
	.gall_box {
		//width: 870px;
		width: 1200px;
		overflow: hidden;
		margin: 0 auto 30px;

		.gall_mbx {
			margin: 0 0 30px;
			padding: 37px 23px 0;

			span {
				font-size: 13px;
			}
		}

		.gall_slt {
			display: flex;
			justify-content: flex-end;
			padding: 0 23px;
			div{
				display: flex;
				cursor: pointer;
				align-items: center;
			}

			.icon {
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}

			span {
				font-size: 15px;
				color: #22AB67;
			}
		}

		.gall_fy {
			margin: 30px 0;

			.block {
				display: flex;
				justify-content: center;
			}
		}

		.gall_cont {
			.gall_item {
				margin-top: 21px;

				.gall_item_title {
					height: 42px;
					background: #F5F5F5;
					padding-left: 23px;
					font-size: 18px;
					color: #333333;
					line-height: 42px;
				}

				.gall_item_p {
					padding: 18px 0 0 23px;
					display: flex;
					flex-wrap: wrap;

					.gall_item_a {
						color: #4A4A4A;
						font-size: 15px;
						margin-bottom: 23px;
						margin-right: 17px;
						display: inline-block;
						padding-bottom: 1px;
						border-bottom: 1px solid #4A4A4A;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
